/* global axios */
import ApiClient from './ApiClient';

class ContactDependentsAPI extends ApiClient {
  constructor() {
    super('contact_dependents', { accountScoped: true });
  }

  // Dependentes de um contato específico.
  list(contactId) {
    return axios.get(this.url, { params: { contact_id: contactId } });
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ContactDependentsAPI();
